import { useTranslation } from 'react-i18next';
import { useOneTrust } from './useOneTrust';

export enum LinkKind {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  ACTION = 'action'
}

export type FooterLink =
  | { kind: LinkKind.INTERNAL; label: string; segment: string; newTab?: boolean }
  | { kind: LinkKind.EXTERNAL; label: string; href: string }
  | { kind: LinkKind.ACTION; label: string; onClick: () => void };

export const resolveFooterPath = (segment: string, isLoggedIn: boolean) =>
  isLoggedIn ? `/dashboard/${segment}` : `/${segment}`;

export const useFooterMenuLinks = (): FooterLink[] => {
  const { t } = useTranslation();

  return [
    { kind: LinkKind.INTERNAL, label: t('menuLabels.testFormats'), segment: 'test-format' },
    {
      kind: LinkKind.INTERNAL,
      label: t('menuLabels.forInstitutions'),
      segment: 'for-institutions'
    },
    { kind: LinkKind.INTERNAL, label: t('menuLabels.helpCenter'), segment: 'help-center' }
  ];
};

export const useFooterLegalLinks = (): FooterLink[] => {
  const { t } = useTranslation();
  const { toggleConsentModal } = useOneTrust();

  return [
    {
      kind: LinkKind.INTERNAL,
      label: t('footerLinks.termsOfUse'),
      segment: 'terms-of-use',
      newTab: true
    },
    {
      kind: LinkKind.EXTERNAL,
      label: t('footerLinks.privacy'),
      href: process.env.REACT_APP_PRIVACY_POLICY_LINK as string
    },
    {
      kind: LinkKind.ACTION,
      label: t('footerLinks.cookies'),
      onClick: toggleConsentModal
    }
  ];
};
